import React from 'react'

import Rating from './Rating'

import { getAggregateFeedback } from '../../../../lib/api'
import useSimpleCache from '../../../../hooks/useSimpleCache'
import { useEnvironment } from '../../../../providers/EnvironmentProvider'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useSurvey } from '../../../../providers/SurveyProvider'
import useUserPermissions from '../../../../hooks/permissions/useUserPermissions'
import useStyles from './styles'

const Satisfaction = ({ user, v2 }) => {
  const { env, loaded } = useEnvironment()
  const { cache, startLoad, endLoad, isCached, isLoading } = useSimpleCache()
  const { conversation } = useQueueState()
  const { updated, markSeen } = useSurvey()
  const { hasBasic } = useUserPermissions()

  const [rating, setRating] = React.useState(null)

  const convoID = React.useMemo(() => conversation?.session, [conversation])
  const isUpdated = React.useMemo(
    () => updated.includes(convoID),
    [updated, convoID]
  )
  const reporting = React.useMemo(() => {
    if (!loaded) {
      return null
    }

    return env.config?.reporting
  }, [loaded, env])

  const classes = useStyles()

  React.useEffect(() => {
    if (!hasBasic) {
      return
    }

    const id = user?.id
    if (!id) {
      return
    }

    if (isCached(id) && !isUpdated) {
      const ratingValue = cache[id]
      //for legacy ratings
      const val = ratingValue === 5 ? 3 : ratingValue === 4 ? 2 : ratingValue
      setRating(val)
      return
    }
    setRating(null)

    if (isLoading(id) || !reporting) {
      return
    }

    const surveyID = reporting.find(
      opt => opt.key === 'r_csat_question_id'
    )?.value
    if (surveyID) {
      startLoad(id)
      getAggregateFeedback(surveyID, id)
        .then(data => {
          markSeen(convoID)
          endLoad(id, data)
        })
        .catch(err => {
          console.error('Error getting aggregate feedback', err)
        })
    }
  }, [
    user,
    isCached,
    cache,
    isLoading,
    reporting,
    startLoad,
    endLoad,
    hasBasic,
    isUpdated,
    markSeen,
    convoID
  ])

  return (
    <div className={classes.root}>
      <Rating rating={rating} />
    </div>
  )
}

export default Satisfaction
